module.exports = __webpack_public_path__ + "static/media/NP.a377eec5.svg";